<template>
    <div class="cover-box" ref="coverDom">
        <div class="cover-img">
            <img :src="publicPath + 'static/images/ShopopeeComCover.jpg'"  alt=""/>
        </div>

        <div class="title-part">
            <p class="name-part-1">{{obj.recordname}}</p>
            <p class="name-part-2">{{obj.addinfo6}}</p>
        </div>
    </div>
</template>

<script setup>

import {onMounted, ref} from "vue";
import html2canvas from "html2canvas";

const props = defineProps(["obj"])
const emits = defineEmits(["print-complete"])

const publicPath = process.env.BASE_URL
const coverDom = ref(null)

function printImg(){
    html2canvas(coverDom.value,{
        useCORS: true
    })
    .then(canvas => { //scala默认1 控制字体线条粗细
        const imgBase64 = canvas.toDataURL("image/jpeg")

        emits("print-complete", imgBase64)

    });
}

onMounted(() => {
    printImg()
})

</script>

<style scoped>
    .cover-box {
        width: 2480px;
        height: 3504px;
        position: relative;
    }

    .cover-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .cover-img img {
        width: 100%;
        height: 100%;
    }

    .title-part {
        position: absolute;
        width: 1250px;
        height: 700px;
        top: 1800px;
        left: 100px;
        text-align: center;
    }

    .name-part-1 {
        font-size: 64px;
        font-weight: 600;
        color: #303133;
    }

    .name-part-2 {
        font-size: 48px;
        color: #606266;
    }
</style>